const IMAGE_TYPES = ["JPG", "JPEG", "PNG", "GIF", "WEBP"];

export function isImageDoc(doc) {
  return IMAGE_TYPES.includes((doc?.type || "").toUpperCase());
}

function escapePdfText(text) {
  return String(text).replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
}

// Construit un PDF minimal (une page, un titre) en data URI — les documents
// mock n'ont pas de fichier réel, ceci donne un aperçu qui s'affiche vraiment
// dans le lecteur PDF natif du navigateur.
export function buildPlaceholderPdfDataUri(doc) {
  const title = escapePdfText(doc.nom || "Document");
  const subtitle = escapePdfText(`${doc.type || "PDF"} · ${doc.taille || ""}`.trim());

  const content = `BT
/F1 18 Tf
72 700 Td
(${title}) Tj
/F1 11 Tf
0 -26 Td
(${subtitle}) Tj
0 -40 Td
(Apercu genere - aucun fichier reel associe a ce document mock.) Tj
ET`;

  const objects = [
    "<< /Type /Catalog /Pages 2 0 R >>",
    "<< /Type /Pages /Kids [3 0 R] /Count 1 >>",
    "<< /Type /Page /Parent 2 0 R /MediaBox [0 0 612 792] /Resources << /Font << /F1 4 0 R >> >> /Contents 5 0 R >>",
    "<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica >>",
    `<< /Length ${content.length} >>\nstream\n${content}\nendstream`,
  ];

  let pdf = "%PDF-1.4\n";
  const offsets = [];
  objects.forEach((obj, i) => {
    offsets.push(pdf.length);
    pdf += `${i + 1} 0 obj\n${obj}\nendobj\n`;
  });

  const xrefStart = pdf.length;
  pdf += `xref\n0 ${objects.length + 1}\n0000000000 65535 f \n`;
  offsets.forEach((offset) => {
    pdf += `${String(offset).padStart(10, "0")} 00000 n \n`;
  });
  pdf += `trailer\n<< /Size ${objects.length + 1} /Root 1 0 R >>\nstartxref\n${xrefStart}\n%%EOF`;

  const base64 = btoa(unescape(encodeURIComponent(pdf)));
  return `data:application/pdf;base64,${base64}`;
}

// Aperçu image placeholder (SVG) — même logique : pas de vrai fichier en mock.
export function buildPlaceholderImageDataUri(doc) {
  const title = (doc.nom || "Document").replace(/[<>&]/g, "");
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="600" height="400">
    <rect width="600" height="400" fill="#F3F4F6"/>
    <rect x="0.5" y="0.5" width="599" height="399" fill="none" stroke="#E7E9EE"/>
    <text x="300" y="190" font-family="sans-serif" font-size="20" fill="#475569" text-anchor="middle">${title}</text>
    <text x="300" y="220" font-family="sans-serif" font-size="13" fill="#94A3B8" text-anchor="middle">${doc.type || "Image"} · ${doc.taille || ""}</text>
  </svg>`;
  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
}

function slugify(text) {
  return String(text)
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/[^a-zA-Z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .toLowerCase() || "document";
}

// Télécharge l'aperçu généré (PDF ou image placeholder, selon doc.type).
export function downloadDoc(doc) {
  const image = isImageDoc(doc);
  const href = image ? buildPlaceholderImageDataUri(doc) : buildPlaceholderPdfDataUri(doc);
  const filename = `${slugify(doc.nom)}.${image ? "svg" : "pdf"}`;

  const link = document.createElement("a");
  link.href = href;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
